import { useMemo } from "react";
import FirmFlowTable from "../../../../components/mytasks/FirmFlowTable";
import ColoredBadge from "../../../../components/ColoredBadge";
import { getClientSubscriptionTypeLabel } from "../../../../helpers/clientSubscriptionTypeLabel";
import truncateText from "../../../../helpers/truncateText";

const RetentionDetailsTable = ({ data }) => {
    const columns = useMemo(
        () => [
            {
                Header: "Client",
                accessor: "clientName",
                Cell: (props) => (
                    <a
                        href={`/clients/manage/${props.row.original.clientId}`}
                        className="text-black-600 hover:underline"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {props.value}
                    </a>
                ),
            },
            {
                Header: "Client Type",
                accessor: "clientType",
                Cell: (props) => {
                    return (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {props.value == 1 ? "Individual" : "Business"}
                        </a>
                    );
                },
            },
            {
                Header: "Subscription Type",
                accessor: "subscriptionType",
                Cell: (props) => {
                    return (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {getClientSubscriptionTypeLabel(props.value) ?? "—"}
                        </a>
                    );
                },
            },
            {
                Header: "Current Status",
                accessor: "isActive",
                Cell: (props) =>
                    props.value ? (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <ColoredBadge
                                colorClass="bg-teal-500 text-white"
                                text="Active"
                            />
                        </a>
                    ) : (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <ColoredBadge
                                colorClass="bg-red-500 text-white"
                                text="Inactive"
                            />
                        </a>
                    ),
            },
            {
                Header: "Teams",
                accessor: "teams",
                Cell: (props) => {
                    const teams = Array.isArray(props.value) ? props.value : [];
                    return teams.length ? (
                        <ul className="pl-4 list-disc">
                            {teams.map((team, i) => (
                                <a
                                    href={`/clients/manage/${props.row.original.clientId}`}
                                    className="text-black-600 hover:underline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <li key={`${team}-${i}`}>{team}</li>
                                </a>
                            ))}{" "}
                        </ul>
                    ) : (
                        <span>—</span>
                    );
                },
            },
            {
                Header: "Managers",
                accessor: "managers",
                Cell: (props) => {
                    const managers = Array.isArray(props.value) ? props.value : [];
                    return managers.length ? (
                        <ul className="pl-4 list-disc">
                            {managers.map((manager, i) => (
                                <a
                                    href={`/clients/manage/${props.row.original.clientId}`}
                                    className="text-black-600 hover:underline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <li key={`${manager}-${i}`}>{manager}</li>
                                </a>
                            ))}
                        </ul>
                    ) : (
                        <span>—</span>
                    );
                },
            },
            {
                Header: "Creation Date",
                accessor: "created",
                Cell: (props) => (
                    <a
                        href={`/clients/manage/${props.row.original.clientId}`}
                        className="text-black-600 hover:underline"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {props.value.toString().split("T")[0]}
                    </a>
                ),
            },
            {
                Header: "Inactive Date",
                accessor: "cancellationDate",
                Cell: (props) => {
                    if (props.row.original.isActive !== false) return null;

                    return props.value ? (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {props.value.toString().split("T")[0]}
                        </a>
                    ) : (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {"Not assigned"}
                        </a>
                    );
                },
            },
            {
                Header: "Cancellation Reason",
                accessor: "inactiveReason",
                Cell: (props) => {
                    if (props.row.original.isActive !== false) return null;

                    return (
                        <a
                            href={`/clients/manage/${props.row.original.clientId}`}
                            className="text-black-600 hover:underline"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {props?.value
                                ? truncateText(props.value)
                                : "Not assigned"}
                        </a>
                    );
                },
            },
        ],
        []
    );
    return (
        <div>
            <FirmFlowTable columns={columns} data={data} />
        </div>
    );
};

export default RetentionDetailsTable;
